import axios from "axios"
import { ticketBaseURL } from "../config/api";

export const getTenantByTenantId = (primaryKey: number) => {
    return getFetch(`mycdirTenants/${primaryKey}`)
}
export const getMycdirTenantForLogin = (primaryKey: number) => {
    return getFetch(`mycdirTenants/GetMycdirTenantForLogin/${primaryKey}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}